import { liveUsageMgmtSliceSelector } from "./liveUsageMgmtSliceSelector";
import { RootState } from "../../../store";

export const liveUsageMgmtRegionsSelector = (
  state: RootState,
): string[] | null => liveUsageMgmtSliceSelector(state).regions;
